

$(document).ready(function() {
  $(document).on('click', '.js_checkout', function(e) {
    e.preventDefault();
  $('#wof_checkout_button').trigger('click');
  });

  $(document).on('change', '#agree', function(e) {
    if ($(this).is(':checked')) {
      $(".cart_terms-error").hide();
    }
  });
});

  
